<div class="flex align-items-center justify-content-start mt-3 w-full">
  <div class="flex align-items-start">
    <p-button label="New" (click)="open()" class="p-button-outlined ml-2" icon="pi pi-plus"
              size="small"></p-button>
  </div>

  <div class="fixed-search-container flex align-items-center justify-content-center flex-grow-1">
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="searchKey"   placeholder="Search.." class=" p-inputtext-sm" (keyup.enter)="searchGST()"/>
        <p-button icon="pi pi-search" (onClick)="searchGST()" [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}"  [raised]="true" [size]="'small'" severity="info"></p-button>
    </span>
</div>
</div>

<p-table #dt1 [value]="gstList" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
    selectionMode="single" (onRowSelect)="SelectOption($event)" (onPage)="loadGST($event)" [paginator]="true" [rows]="10"
    [rowsPerPageOptions]="[10, 15, 20]" [rowHover]="true">
    <ng-template pTemplate="header">
        <tr>
            <th></th>
            <th>HSN Code</th>
            <th>Description Goods and Services</th>
            <th>GST Rate (%)</th>

        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-gst>
        <tr (click)="SelectOption(gst)">
            <td>
                <p-tableRadioButton [value]="gst"></p-tableRadioButton>
            </td>
            <td>{{gst.hsnCode}}</td>
            <td>{{gst.gstDescription}}</td>
            <td>{{gst.gstRate | number: '1.2-2' }}</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Add GST" [modal]="true" [(visible)]="visible" [style]="{width: '60vw'}" [draggable]="false"
[resizable]="false">
<form [formGroup]="createGSTForm">

    <div class="flex align-items-start mt-3">
        <div>
            @if (!isEdit) {
            <p-button label="Save" (onClick)="createGST()" icon="pi pi-save" class="p-button-outlined"
                size="small"></p-button>
            }
            @else {
            <p-button label="Update" severity="info" (click)="update()" icon="pi pi-arrow-circle-up"
                size="small"></p-button>
            }
        </div>

    </div>
                    <div class="grid mt-3">
                <div class="flex gap-3">
                                        <div class="field text-left w-4">
                                            <label class="label-required display">Type</label><br>
                                        <!-- <div class="field text-left"> --><br>
                                <div style="display: flex; gap: 2rem; align-items: center; margin-left: 15px;">
                                <label>
                <input type="radio" formControlName="IsServiceType" [value]="false" /> Goods
                </label>

                <label>
                <input type="radio" formControlName="IsServiceType" [value]="true" /> Service
                </label>

                                </div>

                            <small
                *ngIf="submitted && formControls.IsServiceType.errors"
                class="text-red-500">
                Please select a type (Goods or Service).
                </small> </div></div>
                    </div>

                    <div class="grid mt-3">

                        <div class="col">
                            <div class="field text-left">
                                <label>HSN Code</label>
                                <input pInputText formControlName="HSNCode"
                                    [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.HSNCode.errors}"
                                    class="w-full p-inputtext-sm" />
                            </div>
                        </div>

                        <div class="col">
                            <div class="field text-left">
                                <label>Description</label>
                                <input pInputText formControlName="GSTDescription"
                                    [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.GSTDescription.errors}"
                                    class="w-full p-inputtext-sm" />
                            </div>
                        </div>

                    </div>
      <div class="grid mt-3">
        <div class="col">
            <div class="field text-left">
                <label>GST Rate (%)</label>
                <input pInputText formControlName="GSTRate" type="number" min="0"
                    [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.GSTRate.errors}"
                    class="w-full p-inputtext-sm" />
            </div>
        </div>
<div class="col">
  <div class="field text-left">
    <label for="EffectiveFrom" class="label-required display">Effective Date</label>

    <p-calendar
      formControlName="EffectiveFrom"
      dateFormat="dd/mm/yy"
      [showIcon]="true"
      appendTo="body"
      placeholder="Select Date"
      styleClass="w-full"
      [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.EffectiveFrom.errors}"
    >
    </p-calendar>
    <small
      *ngIf="submitted && createGSTForm.controls.EffectiveFrom.errors"
      class="text-red-500">
      Required field.
    </small>
  </div>
</div>

    </div>
</form>
</p-dialog>
    <p-toast></p-toast>
